import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import moment from "moment";
import "./PackageForm.css"

const PackageHotelBooking = ({ packageId }) => {
  const initialFieldValues = {
    packageHotelBookingId: "00000000-0000-0000-0000-000000000000",
    packageId: packageId || "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    checkInDate: "",
    checkOutDate: "",
    city: "",
    nights: 0,
    hotelName: "",
    roomType: "",
    numberOfRooms: 0,
  };
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [data, setData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);


  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleAddNewClick = () => {
    resetForm();
    setIsFormVisible(true);
  };
  
  const showEditDetails = (data) => {
    const formattedData = {
        ...data,
        checkInDate: moment(data.checkInDate).format('YYYY-MM-DDTHH:mm'),
        checkOutDate: moment(data.checkOutDate).format('YYYY-MM-DDTHH:mm'),
    };
    setRecordForEdit(formattedData);
    setValues(formattedData);
    setIsFormVisible(true);
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  const GetData = async () => {
    const res = await apiService.get(
      `${config.GETHOTELBYPACKAGEID}/${packageId}`
    );
    console.log(res);
    setLists(res.data);
    setData(res.data);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPACKAGEHOTEL, itemToDelete);
        await GetData();
      } catch (error) {
      }
      handleCloseDeleteModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.checkInDate = values.checkInDate === "" ? false : true;
    temp.checkOutDate = values.checkOutDate === "" ? false : true;
    temp.city = values.city === "" ? false : true;
    temp.hotelName = values.hotelName === "" ? false : true;
    temp.roomType = values.roomType === "" ? false : true;
    temp.numberOfRooms = values.numberOfRooms <= 0 ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        packageHotelBookingId: values.packageHotelBookingId,
        packageId: packageId,
        checkInDate: values.checkInDate,
        checkOutDate: values.checkOutDate,
        city: values.city,
        nights: values.nights,
        hotelName: values.hotelName,
        roomType: values.roomType,
        numberOfRooms: values.numberOfRooms,
        userId: user?.id,
      };
      try {
        const isNew =
          formData.packageHotelBookingId ===
          "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEPACKAGEHOTEL, formData);
        } else {
          await apiService.update(config.UPDATEPACKAGEHOTEL, formData);
        }
        await GetData();
        resetForm();
        setIsFormVisible(false);
      } finally {
        setBtnLoading(false);
      }
    }
  };
  const handleCancel = () => {
    resetForm();
    setIsFormVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleDateChange = () => {
    if (values.checkInDate && values.checkOutDate) {
      const checkIn = new Date(values.checkInDate);
      const checkOut = new Date(values.checkOutDate);
      const diffTime = Math.abs(checkOut - checkIn);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setValues({
        ...values,
        nights: diffDays,
      });
    }
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setRecordForEdit(null);
    setBtnLoading(false);
    setErrors({});
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

   useEffect(() => {
    if (packageId) {
      GetData();
    }
  }, [packageId]);

  useEffect(() => {
    handleDateChange();
  }, [values.checkInDate, values.checkOutDate]);

  
 return (
    <div className="PackageHotel-wrapper">
      <div className="card PackageHotel-card">
        <div className="card-body">
          {/* --- HEADER --- */}
          <div className="PackageHotel-header">
            <h4 className="header-title">Hotel Bookings</h4>
            {!isFormVisible && (
              <button
                type="button"
                className="btn btn-primary PackageHotel-btn-gradient"
                onClick={handleAddNewClick}
              >
                <i className="ri-add-line me-1"></i> Add Hotel Stay
              </button>
            )}
          </div>

          {/* --- ADD/EDIT FORM (Conditional) --- */}
          {isFormVisible && (
            <div className="PackageHotel-form-container">
              <h5 className="form-title">
                {values.packageHotelBookingId === "00000000-0000-0000-0000-000000000000"
                  ? "Add Hotel Details"
                  : "Edit Hotel Details"}
              </h5>
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                   <div className="col-lg-3 mb-3">
                      <label className="form-label d-flex align-items-center"><i className="ri-hotel-bed-line me-2"></i>Hotel Name</label>
                      <input type="text" name="hotelName" value={values.hotelName} onChange={handleInputChange} className={"form-control" + applyErrorClass("hotelName")} placeholder="e.g. Burj Al Arab"/>
                       {errors.hotelName === false && <div className="validationerror">Please enter a valid hotel name</div>}
                  </div>
                   <div className="col-lg-3 mb-3">
                      <label className="form-label d-flex align-items-center"><i className="ri-map-pin-line me-2"></i>City</label>
                      <input type="text" name="city" value={values.city} onChange={handleInputChange} className={"form-control" + applyErrorClass("city")} placeholder="e.g. Dubai"/>
                       {errors.city === false && <div className="validationerror">Please enter a valid city</div>}
                  </div>
                  <div className="col-lg-3 mb-3">
                       <label className="form-label d-flex align-items-center"><i className="ri-calendar-event-line me-2"></i>Check-In Date</label>
                       <input type="datetime-local" name="checkInDate" value={values.checkInDate} onChange={handleInputChange} className={"form-control" + applyErrorClass("checkInDate")}/>
                        {errors.checkInDate === false && <div className="validationerror">Please select a valid check-in date</div>}
                  </div>
                  <div className="col-lg-3 mb-3">
                       <label className="form-label d-flex align-items-center"><i className="ri-calendar-check-line me-2"></i>Check-Out Date</label>
                       <input type="datetime-local" name="checkOutDate" value={values.checkOutDate} onChange={handleInputChange} className={"form-control" + applyErrorClass("checkOutDate")}/>
                        {errors.checkOutDate === false && <div className="validationerror">Please select a valid check-out date</div>}
                  </div>
                   <div className="col-lg-3 mb-3">
                       <label className="form-label d-flex align-items-center"><i className="ri-door-open-line me-2"></i>Room Type</label>
                       <select name="roomType" value={values.roomType} onChange={handleInputChange} className={"form-select" + applyErrorClass("roomType")}>
                           <option value="">Select Room Type</option>
                           <option value="Standard">Standard</option>
                           <option value="Deluxe">Deluxe</option>
                           <option value="Suite">Suite</option>
                           <option value="Executive">Executive</option>
                       </select>
                  </div>
                   <div className="col-lg-3 mb-3">
                      <label className="form-label d-flex align-items-center"><i className="ri-hashtag me-2"></i>No of Rooms</label>
                      <input type="number" name="numberOfRooms" value={values.numberOfRooms} onChange={handleInputChange} className={"form-control" + applyErrorClass("numberOfRooms")} min="1"/>
                        {errors.numberOfRooms === false && <div className="validationerror">Please enter a valid number of rooms</div>}
                  </div>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-2">
                    <button type="button" className="btn btn-light" onClick={handleCancel}>Cancel</button>
                    <button type="submit" className="btn btn-primary" disabled={btnLoading}>
                        {btnLoading ? "Saving..." : (values.packageHotelBookingId === "00000000-0000-0000-0000-000000000000" ? "Submit" : "Update")}
                    </button>
                </div>
              </form>
            </div>
          )}

          {/* --- HOTEL LIST TABLE --- */}
          <div className="table-responsive mt-4">
            <table className="table PackageHotel-table">
              <thead className="PackageHotel-table-header">
                <tr>
                  <th>Hotel</th>
                  <th>Check-In</th>
                  <th>Check-Out</th>
                  <th className="text-center">Nights</th>
                  <th>Room Details</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {lists.length > 0 ? (
                  lists.map((v) => (
                    <tr key={v.packageHotelBookingId} className="PackageHotel-table-row">
                      <td>
                        <div className="fw-medium">{v.hotelName}</div>
                        <div className="location-text"><i className="ri-map-pin-2-fill me-1"></i>{v.city}</div>
                      </td>
                      <td>
                        <div className="datetime-text">{moment(v.checkInDate).format("ddd, DD MMM YYYY")}</div>
                        {/* <div className="datetime-text">{moment(v.checkInDate).format("HH:mm A")}</div> */}
                      </td>
                      <td>
                        <div className="datetime-text">{moment(v.checkOutDate).format("ddd, DD MMM YYYY")}</div>
                        {/* <div className="datetime-text">{moment(v.checkOutDate).format("HH:mm A")}</div> */}
                      </td>
                      <td className="text-center">
                        <span className="PackageHotel-nights-badge">{v.nights}</span>
                      </td>
                      <td>
                        <div>{v.roomType}</div>
                        <div className="rooms-text">Rooms: {v.numberOfRooms}</div>
                      </td>
                      <td className="text-center">
                        <div className="d-flex gap-2 justify-content-center">
                           <button className="PackageHotel-action-btn edit" onClick={() => showEditDetails(v)}><i className="ri-pencil-fill"/></button>
                           <button className="PackageHotel-action-btn delete" onClick={() => handleOpenDeleteModal(v.packageHotelBookingId)}><i className="ri-delete-bin-fill"/></button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">
                      <div className="PackageHotel-empty-state">
                          <i className="ri-hotel-line empty-icon"></i>
                          <h5>No Hotels Added Yet</h5>
                          <p>Click "Add Hotel Stay" to get started.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <DeleteAlert show={showDeleteModal} handleClose={handleCloseDeleteModal} handleDelete={handleDelete} />
    </div>
  );
};

export default PackageHotelBooking;